import React, {useEffect, useState} from "react";
import BootstrapTable from "react-bootstrap-table-next";
import {Card, CardBody, CardTitle} from "reactstrap";
import paginationFactory from "react-bootstrap-table2-paginator";

import PersonalTitleFilters from "./_filters";
import GenericSwitch from "../../../components/genericComponents/genericSwitch";
import { showLoader } from "../../../components/loader/loader";
import { confirmAlert } from "react-confirm-alert";
import {ButtonTableDelete, ButtonTableEdit, GenericTableButton} from "../../../components/buttons/buttonsActions";
import { personalTitleService } from "../../../jwt/_services/hotel/personalTitleService";
import { ARE_YOU_SHURE_MSG, ARE_YOU_SHURE_TITLE, LIST, NO, YES } from "../../../components/i18n/i18n";
import LangFormatter from "../../../components/tables/langFormatter";

const PersonalTitleList = (props) => {
    const [fbDataBaseId] = useState(props?.app?.fbDataBase?.id);
    const [listItems, setListItems] = useState([]);
    const [loading, setLoading] = useState(false);

    //Para mostrar en la table
    const [page, setPage] = useState(1);
    const [sizePerPage, setSizePerPage] = useState(10);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [totalSize, setTotalSize] = useState(10);

    //Para guradar los datos a filtrar
    const [dataFilter, setDataFilter] = useState({
        code   : null,
        value  : null,
        status : null,
    });

    useEffect(() => refreshDataList(page, currentIndex, sizePerPage, dataFilter), [props?.updateList]);

    const refreshDataList = (page, currentIndex, sizePerPage, _dataFilters) => {
        setLoading(true);

        personalTitleService.search(currentIndex, sizePerPage, _dataFilters).then(result => {
            if (result){
                setListItems(result.data);
                setTotalSize(result.total);
                setCurrentIndex(currentIndex);
                setPage(page);
                setSizePerPage(sizePerPage);
            } else {
                setListItems([]);
                setTotalSize(0);
                setCurrentIndex(1);
                setPage(1);
                setSizePerPage(10);
            }
        }).finally(() => setLoading(false));
    }

    const handleTableChange = (type, {page, sizePerPage}) => {
        let index = (page - 1) * sizePerPage
        refreshDataList(page, index, sizePerPage,dataFilter);
    };

    const confirmDelete = (data) => {
        return confirmAlert({
            closeOnEscape: true,
            closeOnClickOutside: true,
            customUI: ({onClose}) => {
                return (
                    <div className='custom-ui'>
                        <h1>{ARE_YOU_SHURE_TITLE}</h1>
                        <p>{ARE_YOU_SHURE_MSG}</p>
                        <button onClick={onClose}>{NO}</button>
                        <button className={"btn-alert-delete"} onClick={() => {
                            deleteItem(data)
                            onClose();
                        }}>
                            {YES}
                        </button>
                    </div>
                );
            }
        });
    };

    const deleteItem = (data) => {
        setLoading(true);

        personalTitleService.deleteItem(data.id, fbDataBaseId)
            .then(_ => refreshDataList(page, currentIndex, sizePerPage))
            .finally(()=>setLoading(false));
    }

    const handleSyncItem = (data) => {
        const requestData = {
            fbDataBase: { id: fbDataBaseId },
            item:{ id: data.id }
        }
        setLoading(true);
        personalTitleService.syncOnDemand(requestData)
            .then(result => console.log(result))
            .catch(errorMessage => console.error(errorMessage))
            .finally(() => setLoading(false));
    }

    const editItem = (data) => {
        const itemToEdit = listItems.find(n => n.id === data.id);
        props.setForm(true, itemToEdit, "FORM");
    }

    const actionsFormatter = (cell, row) => <>
        <ButtonTableEdit onClick={() => editItem(row)}/>
        <GenericTableButton onClick={() => handleSyncItem(row)} icon={'fa fa-cloud-upload'}/>
        <ButtonTableDelete onClick={() => confirmDelete(row)}/>
    </>

    const handleStatusChange = async (id, data, status) => await personalTitleService.updateItem(id, {
        fbDataBase:  { id : fbDataBaseId },
        item : { ...data, status:status, id:id }
    })

    const refreshFiltered = (_dataFilter) => {
        setDataFilter(_dataFilter);
        refreshDataList(page, currentIndex, sizePerPage, _dataFilter);
    }

    const columns = [
        {
            dataField: 'id',
            headerStyle: {width: '0px'},
            text: 'ID',
            hidden: true
        }, {
            dataField: 'code',
            text: 'Código',
            headerStyle: {width: '200px'},
        }, {
            dataField: 'name',
            text: 'Nombre',
        }, {
            dataField: 'value',
            text: 'Valor',
        },{
            dataField: 'xapiId',
            text: 'XapiId',
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '50px'},
        },{
            dataField: 'xapiLang',
            text: 'Xapi Lang',
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '100px'},
            formatter: (cell, row) => <LangFormatter
                langCode={row?.xapiLang?.code}
                nativeName={row?.xapiLang?.name}
            />
        }, {
            dataField: 'status',
            text: "Activo",
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '50px'},
            formatter: (cell, row) => <GenericSwitch
                id={ row?.id }
                initialState={ row?.status }
                onChange={ handleStatusChange }
            />
        }, {
            dataField: 'actions',
            isDummyField: true,
            text: 'Acción',
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '200px'},
            formatter: actionsFormatter
        }
    ];

    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"> </i>{LIST}
        </CardTitle>

        <PersonalTitleFilters refreshFiltered={ refreshFiltered } />

        <CardBody className="">
            {loading && showLoader()}
            <BootstrapTable
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listItems}
                columns={columns}
                pagination={paginationFactory({page, sizePerPage, totalSize})}
                onTableChange={handleTableChange}
            />
        </CardBody>
    </Card>
}

export default PersonalTitleList